// extracted by mini-css-extract-plugin
export default {"Menu":"AnswerFeedNavigationMenu_Menu__dXsOh","MenuItem":"AnswerFeedNavigationMenu_MenuItem__jW3Ol"};